<svg
  name="audio-stream"
  fill="none"
  width="64px"
  height="64px"
  viewBox="0 0 1920 1920"
  xmlns="http://www.w3.org/2000/svg"
  stroke="#ffffff"
>
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
    <path
      d="M1129.432 113v1694.148H903.545l-451.772-451.773V564.773L903.545 113h225.887Zm542.545 248.057C1832.017 521.097 1920 733.882 1920 960.107c0 226.226-87.983 438.898-248.023 598.938l-79.851-79.85c138.694-138.582 214.93-323.018 214.93-519.087 0-196.183-76.236-380.506-214.93-519.2ZM338.83 564.773v790.602H169.415C75.672 1355.375 0 1279.703 0 1185.96V734.187c0-93.742 75.672-169.414 169.415-169.414H338.83Zm1093.922 36.085c95.776 97.018 148.407 224.644 148.407 359.16 0 134.628-52.631 262.253-148.407 359.272l-80.303-79.174c74.656-75.897 115.767-175.4 115.767-280.099 0-104.585-41.111-204.088-115.767-279.986Z"
      fill-rule="evenodd"
      fill="#ffffff"
    ></path>
  </g>
</svg>
<svg name="camMic-stream" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="9" height="8" rx="1" fill="white" />
  <path
    d="M10 4.63381V3.36619C10 3.01493 10.1843 2.68942 10.4855 2.5087L12.2428 1.45435C12.576 1.25439 13 1.49445 13 1.8831V6.1169C13 6.50555 12.576 6.74561 12.2428 6.54565L10.4855 5.4913C10.1843 5.31058 10 4.98507 10 4.63381Z"
    fill="white"
  />
</svg>
<svg name="information" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 50 50">
  <path
    d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"
  ></path>
</svg>
<svg name="right-menu-captions" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
  <path
    d="M8.3 2.05v8.5A5.5 5.5 0 0 1 2.77 16h-.68a.67.67 0 0 1-.49-.2.65.65 0 0 1-.2-.48v-1.37c0-.18.06-.34.2-.47.14-.14.3-.2.49-.2h.69c.76 0 1.42-.27 1.96-.8a2.6 2.6 0 0 0 .8-1.93v-.35c0-.28-.1-1.52-.3-1.72a1 1 0 0 0-.73-.3H2.08c-.58 0-1.07-.2-1.47-.6C.2 7.19 0 6.7 0 6.15v-4.1C0 1.49.2 1 .6.6c.41-.4.9-.6 1.48-.6h4.15C6.81 0 7.3.2 7.7.6c.4.4.6.88.6 1.45Zm9.7 0v8.5A5.5 5.5 0 0 1 12.46 16h-.7a.67.67 0 0 1-.48-.2.65.65 0 0 1-.2-.48v-1.37c0-.18.07-.34.2-.47.14-.14.3-.2.49-.2h.7c.76 0 1.4-.27 1.95-.8a2.6 2.6 0 0 0 .81-1.93v-.35c0-.28-.1-1.52-.3-1.72a1 1 0 0 0-.74-.3h-2.42c-.58 0-1.07-.2-1.47-.6-.4-.4-.6-.88-.6-1.44v-4.1c0-.56.2-1.05.6-1.44.4-.4.9-.6 1.47-.6h4.15c.58 0 1.07.2 1.47.6.4.4.61.88.61 1.45Z"
  />
</svg>
<svg name="screen-stream" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 8V1L1 1V8H12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M4.16667 7L3.26492 9.31878C3.13745 9.64654 3.37924 10 3.73092 10H9.26908C9.62076 10 9.86255 9.64655 9.73508 9.31878L8.83333 7"
    fill="white"
  />
  <rect x="1" y="1" width="11" height="7" fill="white" />
</svg>
<svg
  name="stage-layout-focus-icon"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  width="26"
  height="20"
  viewBox="0 0 26 20"
>
  <defs>
    <clipPath id="clip-path">
      <rect
        id="Прямоугольник_158"
        data-name="Прямоугольник 158"
        width="12"
        height="12"
        transform="translate(467 41)"
        fill="#fff"
      />
    </clipPath>
  </defs>
  <g id="zoom_g" transform="translate(-460 -37)">
    <rect
      id="Прямоугольник_154"
      data-name="Прямоугольник 154"
      width="26"
      height="20"
      rx="3"
      transform="translate(460 37)"
      fill="#fff"
    />
    <rect
      id="Прямоугольник_156"
      data-name="Прямоугольник 156"
      width="24"
      height="18"
      rx="2"
      transform="translate(461 38)"
    />
    <g id="Группа_масок_1" data-name="Группа масок 1" clip-path="url(#clip-path)">
      <path
        id="pan_zoom_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24"
        d="M4.267-3.333H5.333a.645.645,0,0,1,.475.192A.645.645,0,0,1,6-2.667a.645.645,0,0,1-.192.475A.645.645,0,0,1,5.333-2H2.667a.645.645,0,0,1-.475-.192A.645.645,0,0,1,2-2.667V-5.333a.645.645,0,0,1,.192-.475A.645.645,0,0,1,2.667-6a.645.645,0,0,1,.475.192.645.645,0,0,1,.192.475v1.067l1.6-1.6A.632.632,0,0,1,5.4-6.05a.632.632,0,0,1,.467.183A.632.632,0,0,1,6.05-5.4a.632.632,0,0,1-.183.467Zm8.4-8.4-1.6,1.6a.632.632,0,0,1-.467.183.632.632,0,0,1-.467-.183A.632.632,0,0,1,9.95-10.6a.632.632,0,0,1,.183-.467l1.6-1.6H10.667a.645.645,0,0,1-.475-.192A.645.645,0,0,1,10-13.333a.645.645,0,0,1,.192-.475A.645.645,0,0,1,10.667-14h2.667a.645.645,0,0,1,.475.192.645.645,0,0,1,.192.475v2.667a.645.645,0,0,1-.192.475.645.645,0,0,1-.475.192.645.645,0,0,1-.475-.192.645.645,0,0,1-.192-.475Z"
        transform="translate(465 55)"
        fill="#fff"
      />
    </g>
  </g>
</svg>
<svg name="stage-layout-main-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="20" viewBox="0 0 26 20">
  <g id="star_g" transform="translate(-490 -37)">
    <rect
      id="Прямоугольник_155"
      data-name="Прямоугольник 155"
      width="26"
      height="20"
      rx="3"
      transform="translate(490 37)"
      fill="#fff"
    />
    <rect
      id="Прямоугольник_157"
      data-name="Прямоугольник 157"
      width="24"
      height="18"
      rx="2"
      transform="translate(491 38)"
    />
    <path
      id="grade_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24"
      d="M6.2-5.028,8.41-6.36l2.208,1.349-.578-2.523,1.945-1.682L9.426-9.443,8.41-11.826,7.394-9.461l-2.558.228,1.945,1.7Zm2.208.315L5.5-2.961a.636.636,0,0,1-.4.105A.677.677,0,0,1,4.73-3,.84.84,0,0,1,4.485-3.3a.613.613,0,0,1-.035-.412l.771-3.311L2.646-9.251a.671.671,0,0,1-.219-.359A.7.7,0,0,1,2.453-10a.751.751,0,0,1,.21-.315.728.728,0,0,1,.385-.158l3.4-.3,1.314-3.119a.629.629,0,0,1,.272-.315.751.751,0,0,1,.377-.105.751.751,0,0,1,.377.105.629.629,0,0,1,.272.315l1.314,3.119,3.4.3a.728.728,0,0,1,.385.158.751.751,0,0,1,.21.315.7.7,0,0,1,.026.394.671.671,0,0,1-.219.359L11.6-7.026l.771,3.311a.613.613,0,0,1-.035.412A.84.84,0,0,1,12.089-3a.677.677,0,0,1-.368.14.636.636,0,0,1-.4-.105ZM8.41-8.235Z"
      transform="translate(494.59 55.584)"
      fill="#fff"
    />
  </g>
</svg>
<svg name="stage-layout-full-screen-icon" width="60" height="40" viewBox="0 0 60 40">
  <g id="_1_g" data-name="1_g" transform="translate(-35 -37)">
    <path
      id="gray_bg"
      d="M5,0H55a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
      transform="translate(35 37)"
    />
    <path
      id="_1"
      data-name="1"
      d="M-230,922h-50a3,3,0,0,1-3-3V889a3,3,0,0,1,3-3h50a3,3,0,0,1,3,3v30A3,3,0,0,1-230,922Zm-25-26a4,4,0,0,0-4,4,4,4,0,0,0,1.352,2.988A8.423,8.423,0,0,0-263,910.934,1.069,1.069,0,0,0-261.933,912h13.866A1.068,1.068,0,0,0-247,910.934a8.424,8.424,0,0,0-5.351-7.947A4,4,0,0,0-251,900,4,4,0,0,0-255,896Zm5.782,13.867h-11.563A5.973,5.973,0,0,1-255,904.646a5.972,5.972,0,0,1,5.781,5.221Zm-5.782-8A1.846,1.846,0,0,1-256.866,900,1.846,1.846,0,0,1-255,898.133,1.847,1.847,0,0,1-253.134,900,1.847,1.847,0,0,1-255,901.866Z"
      transform="translate(320 -847)"
      fill="#010014"
      opacity="0.5"
    />
  </g>
</svg>
<svg name="stage-layout-grid-icon" width="60" height="40" viewBox="0 0 60 40">
  <g id="_2_g" data-name="2_g" transform="translate(-102 -37)">
    <path
      id="Контур_222"
      data-name="Контур 222"
      d="M5,0H55a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
      transform="translate(102 37)"
    />
    <path
      id="_2"
      data-name="2"
      d="M-230,922h-50a3,3,0,0,1-3-3V889a3,3,0,0,1,3-3h50a3,3,0,0,1,3,3v30A3,3,0,0,1-230,922Zm-25-26a4,4,0,0,0-4,4,4,4,0,0,0,1.352,2.988A8.423,8.423,0,0,0-263,910.934,1.069,1.069,0,0,0-261.933,912h13.866A1.068,1.068,0,0,0-247,910.934a8.423,8.423,0,0,0-5.35-7.947A4,4,0,0,0-251,900,4,4,0,0,0-255,896Zm14-2a3,3,0,0,0-3,3,3.006,3.006,0,0,0,1.013,2.241A6.316,6.316,0,0,0-247,905.2a.8.8,0,0,0,.8.8h10.4a.8.8,0,0,0,.8-.8,6.318,6.318,0,0,0-4.013-5.961A3,3,0,0,0-238,897,3,3,0,0,0-241,894Zm-28,0a3,3,0,0,0-3,3,3.006,3.006,0,0,0,1.013,2.241A6.316,6.316,0,0,0-275,905.2a.8.8,0,0,0,.8.8h10.4a.8.8,0,0,0,.8-.8,6.318,6.318,0,0,0-4.013-5.961A3,3,0,0,0-266,897,3,3,0,0,0-269,894Zm19.781,15.867h-11.563A5.973,5.973,0,0,1-255,904.646a5.972,5.972,0,0,1,5.781,5.221Zm12.555-5.467h-8.672A4.478,4.478,0,0,1-241,900.485a4.479,4.479,0,0,1,4.336,3.915Zm-28,0h-8.672A4.478,4.478,0,0,1-269,900.485a4.479,4.479,0,0,1,4.336,3.915Zm9.663-2.535A1.846,1.846,0,0,1-256.866,900,1.846,1.846,0,0,1-255,898.133,1.847,1.847,0,0,1-253.134,900,1.847,1.847,0,0,1-255,901.866Zm14-3.466a1.385,1.385,0,0,1-1.4-1.4,1.385,1.385,0,0,1,1.4-1.4,1.385,1.385,0,0,1,1.4,1.4A1.385,1.385,0,0,1-241,898.4Zm-28,0a1.385,1.385,0,0,1-1.4-1.4,1.385,1.385,0,0,1,1.4-1.4,1.385,1.385,0,0,1,1.4,1.4A1.385,1.385,0,0,1-269,898.4Z"
      transform="translate(387 -847)"
      fill="#010014"
      opacity="0.5"
    />
  </g>
</svg>
<svg name="stage-layout-sidebar-icon" width="60" height="40" viewBox="0 0 60 40">
  <g id="_3_1_g" data-name="3_1_g" transform="translate(-169 -85)">
    <path
      id="Контур_238"
      data-name="Контур 238"
      d="M5,0H55a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
      transform="translate(169 85)"
    />
    <path
      id="_3_1"
      data-name="3_1"
      d="M53,36H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H53a3,3,0,0,1,3,3V33A3,3,0,0,1,53,36ZM9.8,20a.8.8,0,0,0-.8.8,6.318,6.318,0,0,0,4.013,5.96,3,3,0,1,0,3.974,0A6.316,6.316,0,0,0,21,20.8a.8.8,0,0,0-.8-.8H9.8ZM34.066,10A1.068,1.068,0,0,0,33,11.066a8.423,8.423,0,0,0,5.351,7.946,4,4,0,1,0,5.3,0A8.422,8.422,0,0,0,49,11.066,1.068,1.068,0,0,0,47.932,10H34.066ZM9.8,4a.8.8,0,0,0-.8.8,6.318,6.318,0,0,0,4.013,5.96,3,3,0,1,0,3.974,0A6.316,6.316,0,0,0,21,4.8a.8.8,0,0,0-.8-.8H9.8ZM15,30.4A1.4,1.4,0,1,1,16.4,29,1.385,1.385,0,0,1,15,30.4Zm0-4.884A4.479,4.479,0,0,1,10.664,21.6h8.672A4.48,4.48,0,0,1,15,25.516Zm26-1.649A1.867,1.867,0,1,1,42.865,22,1.846,1.846,0,0,1,41,23.867Zm0-6.513a5.971,5.971,0,0,1-5.782-5.221H46.781A5.973,5.973,0,0,1,41,17.354ZM15,14.4A1.4,1.4,0,1,1,16.4,13,1.385,1.385,0,0,1,15,14.4Zm0-4.884A4.479,4.479,0,0,1,10.664,5.6h8.672A4.48,4.48,0,0,1,15,9.516Z"
      transform="translate(227 123) rotate(180)"
      fill="#010014"
      opacity="0.5"
    />
  </g>
</svg>
<svg name="stage-layout-media-icon" width="60" height="40" viewBox="0 0 60 40">
  <g id="_6_g" data-name="6_g" transform="translate(-370 -37)">
    <path
      id="_6"
      data-name="6"
      d="M5,0H55a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
      transform="translate(370 37)"
    />
    <path
      id="_6-2"
      data-name="6"
      d="M-230,539h-50a3,3,0,0,1-3-3V506a3,3,0,0,1,3-3h50a3,3,0,0,1,3,3v30A3,3,0,0,1-230,539Zm-48-33a2,2,0,0,0-2,2v26a2,2,0,0,0,2,2h46a2,2,0,0,0,2-2V508a2,2,0,0,0-2-2Z"
      transform="translate(655 -464)"
      fill="#010014"
      opacity="0.5"
    />
  </g>
</svg>
<svg name="stage-layout-media-sidebar-1-icon" width="60" height="40" viewBox="0 0 60 40">
  <g id="_4_1_g" data-name="4_1_g" transform="translate(-236 -85)">
    <path
      id="Контур_237"
      data-name="Контур 237"
      d="M5,0H55a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
      transform="translate(236 85)"
    />
    <path
      id="_4_1"
      data-name="4_1"
      d="M53,36H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H53a3,3,0,0,1,3,3V33A3,3,0,0,1,53,36ZM24,8a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H51a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2ZM4.066,10A1.068,1.068,0,0,0,3,11.066a8.422,8.422,0,0,0,5.35,7.946,4,4,0,1,0,5.3,0A8.422,8.422,0,0,0,19,11.066,1.068,1.068,0,0,0,17.933,10H4.066ZM11,23.867A1.867,1.867,0,1,1,12.866,22,1.846,1.846,0,0,1,11,23.867Zm0-6.513a5.971,5.971,0,0,1-5.782-5.221H16.781A5.973,5.973,0,0,1,11,17.354Z"
      transform="translate(294 123) rotate(180)"
      fill="#010014"
      opacity="0.5"
    />
  </g>
</svg>
<svg name="stage-layout-media-sidebar-icon" width="60" height="40" viewBox="0 0 60 40">
  <g id="_5_1_g" data-name="5_1_g" transform="translate(-303 -85)">
    <path
      id="_5_1"
      data-name="5_1"
      d="M5,0H55a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z"
      transform="translate(303 85)"
    />
    <path
      id="_5_1-2"
      data-name="5_1"
      d="M53,36H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H53a3,3,0,0,1,3,3V33A3,3,0,0,1,53,36ZM18,4a2,2,0,0,0-2,2V30a2,2,0,0,0,2,2H50a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2ZM2.8,20a.8.8,0,0,0-.8.8,6.319,6.319,0,0,0,4.013,5.96,3,3,0,1,0,3.973,0A6.316,6.316,0,0,0,14,20.8a.8.8,0,0,0-.8-.8H2.8Zm0-16a.8.8,0,0,0-.8.8,6.319,6.319,0,0,0,4.013,5.96,3,3,0,1,0,3.973,0A6.316,6.316,0,0,0,14,4.8a.8.8,0,0,0-.8-.8H2.8ZM8,30.4A1.4,1.4,0,1,1,9.4,29,1.385,1.385,0,0,1,8,30.4Zm0-4.884A4.479,4.479,0,0,1,3.664,21.6h8.672A4.48,4.48,0,0,1,8,25.516ZM8,14.4A1.4,1.4,0,1,1,9.4,13,1.385,1.385,0,0,1,8,14.4ZM8,9.516A4.479,4.479,0,0,1,3.664,5.6h8.672A4.48,4.48,0,0,1,8,9.516Z"
      transform="translate(361 123) rotate(180)"
      fill="#010014"
      opacity="0.5"
    />
  </g>
</svg>
<svg name="video-stream" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 0H0V7H11V0ZM7.25 3.93301C7.58333 3.74056 7.58333 3.25944 7.25 3.06699L5 1.76795C4.66667 1.5755 4.25 1.81606 4.25 2.20096V4.79904C4.25 5.18394 4.66667 5.4245 5 5.23205L7.25 3.93301Z"
    fill="white"
  />
</svg>
<svg name="volume-orange" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="volume_orange" box="15 15">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.87 2.54c-.26-.26-.68-.19-.88.12a.68.68 0 0 0 .1.86 5.6 5.6 0 0 1 0 7.96.68.68 0 0 0-.1.86c.2.3.62.38.88.12a6.84 6.84 0 0 0 0-9.92Zm-1.4 2.15c-.24-.3-.69-.23-.9.09-.18.26-.13.6.06.85a3.1 3.1 0 0 1 0 3.74c-.19.25-.24.6-.06.85.21.32.66.38.9.09a4.35 4.35 0 0 0 0-5.62ZM7.5.62c-.74 0-.96.43-.96.43s-1.91 2.1-3.23 3.03c-.24.16-.5.3-.98.3H1.25C.56 4.38 0 4.92 0 5.63v3.75c0 .68.56 1.24 1.25 1.24h1.08c.47 0 .74.14.98.3 1.32.93 3.23 3.03 3.23 3.03s.22.43.96.43c.69 0 1.25-.56 1.25-1.26V1.88c0-.7-.56-1.25-1.25-1.25Z"
      fill="url(#volume_orange_a)"
    />
    <defs>
      <linearGradient id="volume_orange_a" x1="0" y1="7.5" x2="15" y2="7.5" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
</svg>
<svg name="warning" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
  <path
    fill="#FFBB2C"
    d="M11.53 2.3A1.85 1.85 0 0 0 10 1.21 1.85 1.85 0 0 0 8.48 2.3L.36 16.36C-.48 17.81.21 19 1.88 19h16.24c1.67 0 2.36-1.19 1.52-2.64zM11 16H9v-2h2zm0-4H9V6h2z"
  />
</svg>
<svg name="arrow-down" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="arrow-down" box="20 20">
    <path d="m15 8-5 5-5-5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </g>
</svg>
<svg name="edit" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
  <g box="10 10">
    <path
      d="M9.628 2.059 7.915.34A1.248 1.248 0 0 0 6.253.296L.628 5.942A1.256 1.256 0 0 0 .27 6.7L.003 9.316a.63.63 0 0 0 .385.637.623.623 0 0 0 .24.047h.056l2.606-.238c.286-.029.553-.155.756-.358L9.671 3.76a1.207 1.207 0 0 0-.043-1.7Zm-1.411 1.38L6.542 1.76l.504-.54L8.753 2.93l-.536.509Z"
    />
  </g>
</svg>
<svg name="remove" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
  <g box="14 14">
    <path
      d="M13.42 2.52h-2.34v-1.4C11.08.5 10.56 0 9.92 0H4.08c-.64 0-1.16.5-1.16 1.12v1.4H.58a.57.57 0 0 0-.58.56v.56c0 .08.07.14.15.14h1.1l.45 9.15c.03.6.54 1.07 1.16 1.07h8.28c.62 0 1.13-.47 1.16-1.07l.45-9.15h1.1c.08 0 .15-.06.15-.14v-.56a.57.57 0 0 0-.58-.56Zm-3.65 0H4.23V1.26h5.54v1.26Z"
    />
  </g>
</svg>
<svg
  name="previous"
  fill="#000000"
  width="800px"
  height="800px"
  viewBox="0 0 24 24"
  data-name="Layer 1"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9,24H1a1,1,0,0,1,0-2H9a1,1,0,0,1,0,2Z
  M7,20H1a1,1,0,0,1,0-2H7a1,1,0,0,1,0,2Z
  M5,16H1a1,1,0,0,1,0-2H5a1,1,0,0,1,0,2Z
  M13,23.955a1,1,0,0,1-.089-2A10,10,0,1,0,2.041,11.09a1,1,0,0,1-1.992-.18A12,12,0,0,1,24,12,11.934,11.934,0,0,1,13.09,23.951C13.06,23.954,13.029,23.955,13,23.955Z
  M12,6a1,1,0,0,0-1,1v5a1,1,0,0,0,.293.707l3,3a1,1,0,0,0,1.414-1.414L13,11.586V7A1,1,0,0,0,12,6Z"
  />
</svg>
<svg name="add_user" viewBox="0 0 54 54">
  <path
    d="M23 27a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM18.5 30h9c1.2 0 2.34.5 3.18 1.37a4.76 4.76 0 0 1 1.32 3.3V37H14v-2.33c0-1.24.47-2.43 1.32-3.3A4.42 4.42 0 0 1 18.5 30ZM36 21.76v8.48M40.24 26h-8.49"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
<svg name="logo" viewBox="0 0 260 62">
  <g box="260 62">
    <path
      d="M73.776 10.47 61.394 31.514v14.846h-4.218V31.515L44.792 10.469h4.759l9.733 16.859 9.788-16.859h4.704ZM74.166 33.092c-.072-3.77 1.262-7.033 4.002-9.789 2.775-2.755 6.038-4.096 9.787-4.024 3.785-.072 7.048 1.269 9.788 4.024 2.74 2.756 4.074 6.019 4.002 9.79.072 3.733-1.28 6.996-4.056 9.788-2.776 2.755-6.039 4.097-9.788 4.024-3.75.073-6.994-1.269-9.733-4.024-2.74-2.792-4.074-6.055-4.002-9.789Zm23.306.055c0-2.828-.919-5.203-2.757-7.124-1.803-1.922-4.056-2.883-6.76-2.883-2.704 0-4.975.961-6.813 2.883-1.803 1.885-2.704 4.26-2.704 7.124 0 2.791.901 5.148 2.704 7.07 1.838 1.884 4.091 2.827 6.76 2.827 2.667 0 4.92-.96 6.759-2.882 1.874-1.922 2.811-4.26 2.811-7.015ZM108.739 35.811V19.877h4.11v16.206c0 2.103.631 3.807 1.893 5.112 1.297 1.269 2.938 1.903 4.921 1.903 1.946 0 3.55-.652 4.812-1.957 1.262-1.305 1.893-2.991 1.893-5.058V19.877h4.164v15.934c0 3.3-1.046 5.982-3.137 8.049-2.055 2.066-4.632 3.1-7.732 3.1-3.137 0-5.751-1.034-7.841-3.1-2.055-2.067-3.083-4.75-3.083-8.049ZM171.39 9.817h2.379V46.36h-7.3V27.22l-8.977 11.311h-2.379l-8.977-11.311V46.36h-7.3V9.817h2.379l15.087 19.414L171.39 9.817ZM205.834 35.376H187.07c.432 1.704 1.298 3.027 2.595 3.97 1.334.906 2.975 1.36 4.921 1.36 2.632 0 5.119-.907 7.463-2.72l3.028 5.004c-3.209 2.682-6.778 4.024-10.707 4.024-4.11.072-7.607-1.269-10.491-4.024-2.848-2.792-4.236-6.146-4.164-10.061-.072-3.88 1.28-7.215 4.056-10.006 2.776-2.792 6.093-4.151 9.95-4.079 3.677 0 6.687 1.196 9.031 3.59 2.379 2.392 3.569 5.365 3.569 8.918 0 1.305-.163 2.646-.487 4.024ZM187.07 30.21h12.167c-.036-1.632-.613-2.937-1.731-3.916-1.081-1.015-2.433-1.522-4.055-1.522-1.55 0-2.902.49-4.056 1.468-1.154.979-1.929 2.302-2.325 3.97ZM236.621 35.376h-18.764c.433 1.704 1.298 3.027 2.596 3.97 1.333.906 2.974 1.36 4.92 1.36 2.632 0 5.12-.907 7.463-2.72l3.028 5.004c-3.208 2.682-6.777 4.024-10.707 4.024-4.11.072-7.607-1.269-10.491-4.024-2.848-2.792-4.235-6.146-4.163-10.061-.072-3.88 1.279-7.215 4.055-10.006 2.776-2.792 6.093-4.151 9.95-4.079 3.677 0 6.688 1.196 9.031 3.59 2.379 2.392 3.569 5.365 3.569 8.918 0 1.305-.162 2.646-.487 4.024Zm-18.764-5.166h12.167c-.036-1.632-.613-2.937-1.731-3.916-1.081-1.015-2.433-1.522-4.055-1.522-1.55 0-2.902.49-4.056 1.468-1.153.979-1.929 2.302-2.325 3.97ZM260 40.216v6.145c-1.731.435-3.407.653-5.029.653-3.425 0-6.075-.852-7.949-2.556-1.839-1.704-2.758-4.224-2.758-7.56V25.643h-4.218v-6.2h4.218v-6.797h7.3v6.797h7.571v6.2h-7.571v10.604c0 1.523.379 2.61 1.136 3.263.793.617 2.073.925 3.839.925.613 0 1.767-.073 3.461-.218Z"
      fill="#fff"
    />
    <path d="M0 31V0c17.06 0 30.891 13.88 30.891 31 0 17.12-13.83 31-30.891 31V31Z" fill="url(#logo)" />
    <defs>
      <linearGradient id="logo" x1="30.891" y1="31" x2="0" y2="31" gradientUnits="userSpaceOnUse">
        <stop offset=".427" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
</svg>
<!-- Logo second instance to fix the issue with display: none for the more than one element -->
<svg name="logo2" viewBox="0 0 260 62">
  <g box="260 62">
    <path
      d="M73.776 10.47 61.394 31.514v14.846h-4.218V31.515L44.792 10.469h4.759l9.733 16.859 9.788-16.859h4.704ZM74.166 33.092c-.072-3.77 1.262-7.033 4.002-9.789 2.775-2.755 6.038-4.096 9.787-4.024 3.785-.072 7.048 1.269 9.788 4.024 2.74 2.756 4.074 6.019 4.002 9.79.072 3.733-1.28 6.996-4.056 9.788-2.776 2.755-6.039 4.097-9.788 4.024-3.75.073-6.994-1.269-9.733-4.024-2.74-2.792-4.074-6.055-4.002-9.789Zm23.306.055c0-2.828-.919-5.203-2.757-7.124-1.803-1.922-4.056-2.883-6.76-2.883-2.704 0-4.975.961-6.813 2.883-1.803 1.885-2.704 4.26-2.704 7.124 0 2.791.901 5.148 2.704 7.07 1.838 1.884 4.091 2.827 6.76 2.827 2.667 0 4.92-.96 6.759-2.882 1.874-1.922 2.811-4.26 2.811-7.015ZM108.739 35.811V19.877h4.11v16.206c0 2.103.631 3.807 1.893 5.112 1.297 1.269 2.938 1.903 4.921 1.903 1.946 0 3.55-.652 4.812-1.957 1.262-1.305 1.893-2.991 1.893-5.058V19.877h4.164v15.934c0 3.3-1.046 5.982-3.137 8.049-2.055 2.066-4.632 3.1-7.732 3.1-3.137 0-5.751-1.034-7.841-3.1-2.055-2.067-3.083-4.75-3.083-8.049ZM171.39 9.817h2.379V46.36h-7.3V27.22l-8.977 11.311h-2.379l-8.977-11.311V46.36h-7.3V9.817h2.379l15.087 19.414L171.39 9.817ZM205.834 35.376H187.07c.432 1.704 1.298 3.027 2.595 3.97 1.334.906 2.975 1.36 4.921 1.36 2.632 0 5.119-.907 7.463-2.72l3.028 5.004c-3.209 2.682-6.778 4.024-10.707 4.024-4.11.072-7.607-1.269-10.491-4.024-2.848-2.792-4.236-6.146-4.164-10.061-.072-3.88 1.28-7.215 4.056-10.006 2.776-2.792 6.093-4.151 9.95-4.079 3.677 0 6.687 1.196 9.031 3.59 2.379 2.392 3.569 5.365 3.569 8.918 0 1.305-.163 2.646-.487 4.024ZM187.07 30.21h12.167c-.036-1.632-.613-2.937-1.731-3.916-1.081-1.015-2.433-1.522-4.055-1.522-1.55 0-2.902.49-4.056 1.468-1.154.979-1.929 2.302-2.325 3.97ZM236.621 35.376h-18.764c.433 1.704 1.298 3.027 2.596 3.97 1.333.906 2.974 1.36 4.92 1.36 2.632 0 5.12-.907 7.463-2.72l3.028 5.004c-3.208 2.682-6.777 4.024-10.707 4.024-4.11.072-7.607-1.269-10.491-4.024-2.848-2.792-4.235-6.146-4.163-10.061-.072-3.88 1.279-7.215 4.055-10.006 2.776-2.792 6.093-4.151 9.95-4.079 3.677 0 6.688 1.196 9.031 3.59 2.379 2.392 3.569 5.365 3.569 8.918 0 1.305-.162 2.646-.487 4.024Zm-18.764-5.166h12.167c-.036-1.632-.613-2.937-1.731-3.916-1.081-1.015-2.433-1.522-4.055-1.522-1.55 0-2.902.49-4.056 1.468-1.153.979-1.929 2.302-2.325 3.97ZM260 40.216v6.145c-1.731.435-3.407.653-5.029.653-3.425 0-6.075-.852-7.949-2.556-1.839-1.704-2.758-4.224-2.758-7.56V25.643h-4.218v-6.2h4.218v-6.797h7.3v6.797h7.571v6.2h-7.571v10.604c0 1.523.379 2.61 1.136 3.263.793.617 2.073.925 3.839.925.613 0 1.767-.073 3.461-.218Z"
      fill="#fff"
    />
    <path d="M0 31V0c17.06 0 30.891 13.88 30.891 31 0 17.12-13.83 31-30.891 31V31Z" fill="url(#logo2)" />
    <defs>
      <linearGradient id="logo2" x1="30.891" y1="31" x2="0" y2="31" gradientUnits="userSpaceOnUse">
        <stop offset=".427" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
</svg>
<svg name="logo-mini" viewBox="0 0 16 32">
  <g box="16 32">
    <path d="M0 16V0a16 16 0 1 1 0 32V16Z" fill="url(#3)" />
    <defs>
      <linearGradient id="3" x1="16" y1="16" x2="0" y2="16" gradientUnits="userSpaceOnUse">
        <stop offset=".43" stop-color="#FF7F00" />
        <stop offset="1" stop-color="#EEA823" />
      </linearGradient>
    </defs>
  </g>
</svg>
<svg name="console" viewBox="0 0 24 24">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7ZM7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H7ZM7 17C7 16.4477 7.44772 16 8 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17ZM8.70709 7.29288C8.31656 6.90236 7.6834 6.90238 7.29288 7.29291C6.90236 7.68344 6.90238 8.3166 7.29291 8.70712L9.58588 11L7.29291 13.2929C6.90238 13.6834 6.90236 14.3166 7.29288 14.7071C7.6834 15.0976 8.31656 15.0976 8.70709 14.7071L11.7072 11.7071C11.8948 11.5196 12.0001 11.2652 12.0001 11C12.0001 10.7348 11.8948 10.4804 11.7072 10.2929L8.70709 7.29288Z"
  />
</svg>
<svg name="close" viewBox="0 0 14 14">
  <path
    d="m8.54 7 5.24-5.23a.76.76 0 0 0 0-1.09l-.46-.46a.76.76 0 0 0-.54-.22c-.2 0-.4.08-.55.22L7 5.46 1.77.22A.76.76 0 0 0 1.22 0c-.2 0-.4.08-.54.22L.22.68c-.3.3-.3.79 0 1.09L5.46 7 .22 12.23a.76.76 0 0 0-.22.55c0 .2.08.4.22.54l.46.46c.15.14.34.22.54.22s.4-.08.55-.22L7 8.54l5.23 5.24c.15.14.34.22.55.22.2 0 .4-.08.54-.22l.46-.46a.76.76 0 0 0 .22-.54c0-.2-.08-.4-.22-.55L8.54 7Z"
    fill="#959595"
  />
</svg>
<svg name="person" viewBox="0 0 48 48">
  <path d="M0 0h48v48H0z" fill="none" />
  <g id="Shopicon">
    <path
      d="M31.278,25.525C34.144,23.332,36,19.887,36,16c0-6.627-5.373-12-12-12c-6.627,0-12,5.373-12,12
      c0,3.887,1.856,7.332,4.722,9.525C9.84,28.531,5,35.665,5,44h38C43,35.665,38.16,28.531,31.278,25.525z M16,16c0-4.411,3.589-8,8-8
      s8,3.589,8,8c0,4.411-3.589,8-8,8S16,20.411,16,16z M24,28c6.977,0,12.856,5.107,14.525,12H9.475C11.144,33.107,17.023,28,24,28z"
    />
  </g>
</svg>
<svg name="copy" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
  <path
    d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
  />
</svg>
<svg name="signal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 24" width="30" height="24">
  <rect x="2" y="18" width="4" height="4" rx="1" fill="#D1D5DB" />
  <rect x="8" y="15" width="4" height="7" rx="1" fill="#D1D5DB" />
  <rect x="14" y="12" width="4" height="10" rx="1" fill="#D1D5DB" />
  <rect x="20" y="8" width="4" height="14" rx="1" fill="#D1D5DB" />
  <rect x="26" y="4" width="4" height="18" rx="1" fill="#D1D5DB" />
</svg>
<svg name="signal-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 24" width="30" height="24">
  <rect x="2" y="18" width="4" height="4" rx="1" fill="#EF4444" />
  <rect x="8" y="15" width="4" height="7" rx="1" fill="#D1D5DB" />
  <rect x="14" y="12" width="4" height="10" rx="1" fill="#D1D5DB" />
  <rect x="20" y="8" width="4" height="14" rx="1" fill="#D1D5DB" />
  <rect x="26" y="4" width="4" height="18" rx="1" fill="#D1D5DB" />
</svg>
<svg name="signal-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 24" width="30" height="24">
  <rect x="2" y="18" width="4" height="4" rx="1" fill="#EF4444" />
  <rect x="8" y="15" width="4" height="7" rx="1" fill="#EF4444" />
  <rect x="14" y="12" width="4" height="10" rx="1" fill="#D1D5DB" />
  <rect x="20" y="8" width="4" height="14" rx="1" fill="#D1D5DB" />
  <rect x="26" y="4" width="4" height="18" rx="1" fill="#D1D5DB" />
</svg>
<svg name="signal-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 24" width="30" height="24">
  <rect x="2" y="18" width="4" height="4" rx="1" fill="#EF4444" />
  <rect x="8" y="15" width="4" height="7" rx="1" fill="#EF4444" />
  <rect x="14" y="12" width="4" height="10" rx="1" fill="#EF4444" />
  <rect x="20" y="8" width="4" height="14" rx="1" fill="#D1D5DB" />
  <rect x="26" y="4" width="4" height="18" rx="1" fill="#D1D5DB" />
</svg>
<svg name="signal-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 24" width="30" height="24">
  <rect x="2" y="18" width="4" height="4" rx="1" fill="#F97316" />
  <rect x="8" y="15" width="4" height="7" rx="1" fill="#F97316" />
  <rect x="14" y="12" width="4" height="10" rx="1" fill="#F97316" />
  <rect x="20" y="8" width="4" height="14" rx="1" fill="#F97316" />
  <rect x="26" y="4" width="4" height="18" rx="1" fill="#D1D5DB" />
</svg>
<svg name="signal-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 24" width="30" height="24">
  <rect x="2" y="18" width="4" height="4" rx="1" fill="#22C55E" />
  <rect x="8" y="15" width="4" height="7" rx="1" fill="#22C55E" />
  <rect x="14" y="12" width="4" height="10" rx="1" fill="#22C55E" />
  <rect x="20" y="8" width="4" height="14" rx="1" fill="#22C55E" />
  <rect x="26" y="4" width="4" height="18" rx="1" fill="#22C55E" />
</svg>
<svg
  name="microphone"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="M395-435q-35-35-35-85v-240q0-50 35-85t85-35q50 0 85 35t35 85v240q0 50-35 85t-85 35q-50 0-85-35Zm45 315v-123q-104-14-172-93t-68-184h80q0 83 58.5 141.5T480-320q83 0 141.5-58.5T680-520h80q0 105-68 184t-172 93v123h-80Z"
  />
</svg>
<svg
  name="video_camera"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h480q33 0 56.5 23.5T720-720v180l160-160v440L720-420v180q0 33-23.5 56.5T640-160H160Z"
  />
</svg>
<svg
  name="display"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="M720-600v-120H600v-80h120v-120h80v120h120v80H800v120h-80Zm-80 480H320v-80H160q-33 0-56.5-23.5T80-280v-480q0-33 23.5-56.5T160-840h374q-7 19-10.5 39t-3.5 41q0 100 70 170t170 70q33 0 63.5-8.5T880-552v272q0 33-23.5 56.5T800-200H640v80Z"
  />
</svg>
<svg
  name="person_add"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="M720-400v-120H600v-80h120v-120h80v120h120v80H800v120h-80ZM247-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Z"
  />
</svg>
<svg
  name="screen_cast"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="m480-420 240-160-240-160v320ZM228-85q-33 5-59.5-15.5T138-154L85-591q-4-33 16-59t53-30l46-6v326q0 66 47 113t113 47h372q-6 24-24 41.5T664-138L228-85Zm132-195q-33 0-56.5-23.5T280-360v-440q0-33 23.5-56.5T360-880h440q33 0 56.5 23.5T880-800v440q0 33-23.5 56.5T800-280H360Z"
  />
</svg>
<svg
  name="settings"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="M560-80q-17 0-28.5-11.5T520-120v-240q0-17 11.5-28.5T560-400h240q17 0 28.5 11.5T840-360v80l80-80v240l-80-80v80q0 17-11.5 28.5T800-80H560Zm-190 0-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v13.5H622q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 48 27 84t71 50v266h-70Z"
  />
</svg>
<svg
  name="contact_support"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="m480-80-10-120h-10q-142 0-241-99t-99-241q0-142 99-241t241-99q71 0 132.5 26.5t108 73q46.5 46.5 73 108T800-540q0 75-24.5 144t-67 128q-42.5 59-101 107T480-80Zm8-253q12-12 12-29t-12-29q-12-12-29-12t-29 12q-12 12-12 29t12 29q12 12 29 12t29-12Zm-58-115h60q0-30 6-42t38-44q18-18 30-39t12-45q0-51-34.5-76.5T460-720q-44 0-74 24.5T344-636l56 22q5-17 19-33.5t41-16.5q27 0 40.5 15t13.5 33q0 17-10 30.5T480-558q-35 30-42.5 47.5T430-448Z"
  />
</svg>
<svg
  name="volume-up"
  xmlns="http://www.w3.org/2000/svg"
  height="24px"
  viewBox="0 -960 960 960"
  width="24px"
  fill="#e3e3e3"
>
  <path
    d="M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm440 40v-322q47 22 73.5 66t26.5 96q0 51-26.5 94.5T560-320Z"
  />
</svg>
